import template from './mapnav.html';
import controller from './mapnav.controller';
import './mapnav.scss';

let mapnavComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default mapnavComponent;
